// extracted by mini-css-extract-plugin
export default {"step":"ModalFooter_step__J2d3S"};